import { Box, Stack } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  handleClick?: (event: React.MouseEvent<HTMLElement>) => void;
  children: ReactNode;
}

const SidebarIconFrame: FC<Props> = ({ handleClick, children }) => {
  return (
    <Stack
      sx={{
        height: 42,
        width: 42,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '12px',
        cursor: 'pointer',
        position: 'relative',
        backgroundImage: 'linear-gradient(0deg, rgba(27, 27, 27, 1) 0%, rgba(125, 125, 125, 1) 100%)',
        '&::before': {
          content: "''",
          position: 'absolute',
          top: '7px',
          height: '100%',
          width: '100%',
          borderRadius: '10px',
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '2px',
          backgroundImage: 'linear-gradient(45deg, rgba(125, 125, 125, 1) 0%, rgba(250, 250, 250, 1) 100%)',
          zIndex: -1,
        },
        '&::after': {
          content: "''",
          position: 'absolute',
          height: '90%',
          width: '90%',
          borderRadius: '10px',
          backgroundColor: ({ palette }) => palette.background.paper,
          zIndex: 3,
        },
        '& svg': {
          zIndex: 10,
        },
      }}
      justifyContent="center"
      alignItems="center"
      onClick={(e) => {
        handleClick?.(e);
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: 0,
          height: 0,
          bottom: '-4px',
          right: '2px',
          borderLeft: '6px solid transparent',
          borderBottom: ({ palette }) => `6px solid ${palette.background.paper}`,
          zIndex: 10,
        }}
      />
      {children}
    </Stack>
  );
};
export default SidebarIconFrame;
